export default __webpack_public_path__ + "static/media/ic_avax_30.845f1431.svg";